import { maybe } from '@passionware/monads';
import { devOriginEvents } from 'v5/platform/dev-origin/devOrigin.protocol';
import {
  createDevOriginService,
  DevOriginChannel
} from './DevOriginService.impl';

function viteDevOriginChannel(
  hot: NonNullable<ImportMeta['hot']>
): DevOriginChannel {
  return {
    request: () => hot.send(devOriginEvents.request),
    onOrigin: listener => hot.on(devOriginEvents.update, listener),
    onConnect: listener => hot.on('vite:ws:connect', () => listener())
  };
}

// `import.meta.hot` only exists under the dev server, where `vite-plugins/devOrigin.ts` answers
export const myDevOriginService = createDevOriginService(
  maybe.map(import.meta.hot, viteDevOriginChannel)
);
